import { render, staticRenderFns } from "./VideoMessageBalloon.vue?vue&type=template&id=5d795092&scoped=true&"
import script from "./VideoMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./VideoMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./VideoMessageBalloon.vue?vue&type=style&index=0&id=5d795092&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d795092",
  null
  
)

export default component.exports